/**
 *
 * @param siteSearchElements
 */
const siteSearch = (siteSearchElements) => {
  if (!siteSearchElements) {
    return;
  }

  siteSearchElements.forEach( (siteSearchElement) => {
    const searchToggleButton = siteSearchElement.querySelector( 'button[aria-haspopup]' );
    const searchButtonText = searchToggleButton.querySelector( 'span' );
    const searchMenu = siteSearchElement.querySelector( '.site-search__menu' );
    const searchBackdrop = siteSearchElement.querySelector( '.site-search__backdrop' );

    /**
     * Close the search menu
     */
    const closeSearch = () => {
      searchToggleButton.setAttribute( 'aria-expanded', 'false' );
      searchButtonText.textContent = 'Zoeken';
    }

    /**
     * Open the search menu
     */
    const openSearch = () => {
      searchToggleButton.setAttribute( 'aria-expanded', 'true' );
      searchButtonText.textContent = 'Sluiten';

      // Enforce the navigation to be closed.
      window.dispatchEvent( new CustomEvent( "closeNavigation", {
        detail: { focus: false }
      } ) );
    }

    /**
     * Handle keydown event for the escape key
     * @param event
     */
    const handleKeydown = (event) => {
      const isEscPressed = (event.key === 'Escape');

      if (isEscPressed) {
        closeSearch();
        searchToggleButton.focus();
      }
    }

    /**
     * Handle focus out event
     * @param event
     */
    const handleFocusOut = (event) => {
      const isExpanded = searchToggleButton.getAttribute( 'aria-expanded' ) === 'true';

      if (isExpanded && event.relatedTarget && !searchMenu.contains( event.relatedTarget )) {
        closeSearch();
      }
    }

    /**
     * Handle click outside event
     * @param event
     */
    const handleClickOutside = (event) => {
      const isExpanded = searchToggleButton.getAttribute( 'aria-expanded' ) === 'true';
      const isBackdrop = searchBackdrop.contains( event.target );

      if (isExpanded && isBackdrop) {
        event.preventDefault();
        closeSearch();
      }
    }

    /**
     * Handle search toggle event
     * @param {object} event The event object.
     */
    const handleSearchToggle = (event) => {
      event.preventDefault();
      const {target} = event;

      target.getAttribute( 'aria-expanded' ) === 'true'  ? closeSearch() : openSearch();
    }

    searchToggleButton.addEventListener( 'click', handleSearchToggle );
    siteSearchElement.addEventListener( 'focusout', handleFocusOut );
    document.addEventListener( 'click', handleClickOutside );
    window.addEventListener( 'keydown', handleKeydown );
  } )
}

export default siteSearch;
